import { render, staticRenderFns } from "./Profile.vue?vue&type=template&id=6b965864&scoped=true"
import script from "./Profile.vue?vue&type=script&lang=js"
export * from "./Profile.vue?vue&type=script&lang=js"
import style0 from "./Profile.vue?vue&type=style&index=0&id=6b965864&prod&scoped=true&lang=css"
import style1 from "./Profile.vue?vue&type=style&index=1&id=6b965864&prod&lang=css"
import style2 from "./Profile.vue?vue&type=style&index=2&id=6b965864&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b965864",
  null
  
)

export default component.exports